// PageOneCalOMS Questionnaire
export const cid2 =
  "Provider's Client ID: (This is an identifier assigned by the provider to the participant).";
export const cid3 = 'What is you gender ?';
export const cid4 = 'What is your Date of Birth ?';
export const cid5 = 'What is your current first name ?';
export const cid6 = 'What is your current last name ?';
export const cid7 =
  'What is your current social security number ? (A nine digit social security number).';
export const cid8 = `What is your zip code at current resisence ? (The client's five digit zip code. If Client is homeless then Zip code must be '00000' and current living arguments (SOC-2) must be (Homeless)).`;
export const cid9 = 'What is your birth first name ?';
export const cid10 = 'What is your birth last name ?';
export const cid11A = 'If born in California, what is your county of birth';
export const cid11B = 'If born in U.S, what is your state of birth';
export const cid12 = `What is your driver's license number? If you do not have a driver's license, what is your state identification card number? (Must be an alphanumeric value upto 13 characters in length with at least one character).`;
export const cid13 = `For which state do you have a valid driver's license or state identification card ?`;
export const cid14 = `What is your mother's first name ?`;
export const cid15 = 'What is race ?';
export const cid16 = 'What is your ethnicity ?';
export const cid17 = 'Are you U.S. veteran ?';
export const cid18 = 'What type of disability do you have, if any ?';
export const cid19 = `Have you signed and submitted to this Agency for file a consent from allowing future possible contact ?`;

// PageTwoCalOMS Questionnaire
export const adm2 = 'Admission Transaction Type :';
export const adm3 = `ADP issued Provider ID : (Provider ID must be exactly 6 digits in lengthand must match ADP's Master Provider File(MPF)).`;
export const adm4 = 'Type of Service :';
export const adm5 = 'What is your principal source of referal ?';
export const adm6 = `How many days were you on a waiting list before you were admitted to this treatment program ?`;
export const adm7 = `What is the number of prior episodes in any alcohol or drug treatment / recovery program in which you have participated ?`;
export const adm8 = 'Are you CalWORKs recipient ?';
export const adm9 = `Are you substance abuse treatment client under CaIWORKsrecipient's welfare-to-work plan ?`;
export const adm10 = `What county is paying for the services which are being delivered ?`;
export const adu1a = `What is your primary alcohol or drug problem ?`;
export const adu1b = `Primary Drug Name : (Drug name required when the following drugs are entered in the Primary Drug (ADU-1a): Barbiturates, Other Sedatives or Hyponotics, Other Amphetamines, Other Stimulants, Other Hallucinogens, Tranquilzers(eg: Benzodiazepine), Other Tranquilizers, Inhalants, Over-the-Counter, or Other Club Drugs or Other).`;
export const adu2 = `How many days in the past 30days have you used the primary drug ?`;
export const adu3 = `What is your usual route of administration for the primary drug ?`;
export const adu4 = `What is your age the first time you used the primary drug ?`;

// PageThreeCalOMS Questionnaire
export const adu5a = `What is your secondary alcohol or drug problem ?`;
export const adu5b = `Secondary Drug Name : (Drug name required when the following drugs are entered in the Secondary Drug (ADU-5a): Barbiturates, Other Sedatives or Hyponotics, Other Amphetamines, Other Stimulants, Other Hallucinogens, Tranquilzers (eg: Benzodiazepine), Other Tranquilizers, Inhalants, Over-the-Counter, Other Club Drugs or Other).`;
export const adu6 = `How many days in the past 30 days have you used the secondary drug ?`;
export const adu7 = `What is your usual route of administration for the secondary drug ?`;
export const adu8 = `What was your age the first time you used the secondary drug ?`;
export const adu9 = `How many days in the past 30 days have you used alcohol ? (If primary drug code(ADU-1a) or secondary drug code (ADU-5a)are 2 (alcohol), alcohol frequency (ADU-9 must be (None or not applicable))).`;
export const adu10 = `How many days in the past 30 days have you used needles ?`;
export const adu11 = `Have you used needles to inject in the past 12 months ?`;
export const emp1 = `What is your current employement status ? (If client is 14 years of age or less, then employement status cannot be (Employee Full Time)).`;
export const emp2 = `How many days were you paid for working in the past 30 days ?`;
export const emp3 = `Are you currently enrolled in school ?`;
export const emp4 = `Are you currently enrolled in a job training program ?`;
export const emp5 = `What is your highest school grade completed ?`;
export const leg1 = `What is your criminal justice status ?`;
export const leg2 = `What is your CA Department of Corrections(CDC) identification number
? (If Parolee Services Network (LEG-6) is Yes, then a CDC Number
(LEG-2) must be provided.If FOTP Parolee (LEG-7) is Yes, then CDC
Number (LEG2) must be provided).`;
export const leg3 = `How many times have you been arrested in the past 30 days ?`;
export const leg4 = `How many days have you been in jail in the past 30 days ?`;
export const leg5 = `How many days have you been in prision in the past 30 days ?`;
export const leg6 = `Are you a parolee in the Parolee Service Network (PSN) ? (If Parolee
            Service Network(LEG-6) is Yes, then a CDC Number (LEG-2) must be
            provided).`;
export const leg7 = `Are you a parolee in the Female Offender Treatement Program(FOTP) ?
            (If FOTP perolee(LEG-7) is Yes, then a CDC Number (LEG-2) must be
            provided. if FOTP Perolee (LEG-7 is Yes, then Gender (CID-3 must be
            Female))).`;

// PageFourCalOMS Questionnaire
export const leg8 = `What is your FOTP priority status ? (if FOTP priority status (LEG-8)
            is 1,2, or 3, then FOTP Parolee (LEG-7) cannot be No).`;
export const med1 = `Are you a Medi-Cal benefciary ?`;
export const med2 = `How many times have you visited an ER in the past 30 days for a
            physical health problem ?`;
export const med3 = `How many days have you stayed overnight in a hospital in the past 30
            days for a physical health problem ?`;
export const med4 = `How many days in the past 30 days have you expirienced physical
            health problems ? (If Emergency Room past 30 days (MED-2) or
            Hospital Overnight past 30 days (MED-3) are greater than 0, then
            Medical Problems past 30 days (MED-4) must be greater than 0).`;
export const med5 = `If female, are you pregnant ?`;
export const med7 = `What medication is prescribed as a part of treatment ? If med is 2
            or 3, provider must be a licensed narcotics replacement provider.`;
export const med8 = `Have you been diagnosed with Tuberculosis ?`;
export const med9 = `Have you been diagnosed with Hepatitis C ?`;
export const med10 = `Have you been diagnosed with Sexually transmitted disease ?`;
export const med11 = `Have you been tested for HIV / AIDS ?`;
export const med12 = `Do you have the results of the HIV / AIDS test ? (HIV Test Results
    (MED-12) can only be Yes when HIV Tested (MED-11) is Yes).`;
export const mhd1 = `Have you ever been diagnosed with a mental illness ?`;
export const mhd2 = `How many times in the past 30 days have you recieved outpatient
            emergency services for mental health needs ?`;
export const mhd3 = `How many days in the past 30 days have you stayed for more than 24
            hours in a hospital or psychiatric facility for mental health needs ?`;
export const mhd4 = `In the past 30 days, have you taken prescribed medication for mental
            health needs ?`;
export const soc1 = `How many days in the past 30 days have you participated in any
            social support recovery activities such as: 12 step meetings; other
            self help meetings; religious self help meetings; attended meetings
            or organizations other than those listed above; interactions with
            family and or friend in support of recovery ?`;
export const soc2 = `What are your current living arrangements ? (Current Living
            Arrangements can be (Homeless) only when Zip Code at Current
            Residence (CID-8) is 00000).`;
export const soc3 = `How many days in the past 30 days have you lived with someone who
            uses alcohol or drugs ?`;
export const soc4 = `How many days in the past 30 days have you had serious conflict with
            your family ?`;
export const soc5 = `How many children do you have aged 17 or less (birth or adopted)
            whether they live with you or not ?`;
export const soc6 = `How many children do you have aged 5 or younger ? (<=SOC-5)`;
export const soc7 = `How many of your children are living with someone else because of a
            child protection court order ? (This number must be less than or
            equal to Numbeer of Children (SOC-5)).`;
export const soc8 = `If you have children living with someone else because of a child
            protection order, for how many of these children have your parental
            rights been terminated ? (This number must be less than or equal to
            Number of Children (SOC-5)).`;
export const lgbtq = `Are you Heterosexual, Lesbian, Gay, Bisexual, Transgender or do you
            Question your Sexual Orientation ?`;

// PageOneCalOMSDischarge Questionnaire
export const dis2 = 'Discharge Status ?';

// PageTwoCalOMSDischarge Questionnaire
export const med6 = `If female, were you pregnant during treatment ?`;
